import React, { useState, useEffect } from 'react';
import GridDefaultShimmer from '../../../components/GridDefaultShimmer/GridDefaultShimmer';
import PageHeader from '../../../components/PageHeader/PageHeader';

const LaborConditionChangedReport = (props) => {

    const [data, setData] = useState([]);
    const [columns, setColumns] = useState([{
        name: 'Ажилтны нэр',
        fieldName: 'empfirstname'
    }, {
        name: 'Хуулийн этгээд',
        fieldName: 'companyname'
    }, {
        name: 'Ажлын байр',
        fieldName: 'jobname'
    }, {
        name: 'Тушаалын дугаар ',
        fieldName: 'orderno'
    }, {
        name: 'Хөдөлмөрийн нөхцөл',
        fieldName: 'labourconditionname'
    }, {
        name: 'Даатгуулагчийн төрөл',
        fieldName: 'insuretypename'
    }, {
        name: 'Эхэлсэн огноо',
        fieldName: 'begindate'
    }, {
        name: 'Дууссан огноо',
        fieldName: 'enddate'
    }, {
        name: 'Хүйс',
        fieldName: 'empgendername'
    }]);
    const [loading, setLoading] = useState(false);

    const getData = async () => {
        setLoading(true);
        let tData = [];
        tData = [];
        setData(tData);
        setLoading(false);
    }

    useEffect(() => {
        getData();
    }, []);

    const onSearch = (p_data) => {
        setData(p_data);
    }

    const onGridFilterChange = async (p_gridfiltervalue) => {
        getData(p_gridfiltervalue);
    }
    
    return (
        <div>
            <PageHeader
                title='Даатгуулагчийн төрөл өөрчлөгдсөн'
                columns={columns}
                data={data}
                filteredData={data}
                onSearch={onSearch}
                gridFilter={[]}
                dataCount={data.length}
                onGridFilterChange={onGridFilterChange}
                loading={loading}
            />
            <GridDefaultShimmer
                data={data}
                columns={columns}
                loading={loading}
            />
        </div>
    );
}

export default LaborConditionChangedReport;